import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { range } from 'lodash';
import { List, Map } from 'immutable';

import Form from '../Form';

const APPLICABLE_TO = [
    { id: 'sport', label: 'Sport' },
    { id: 'event', label: 'Event' },
    { id: 'competition', label: 'Competition' },
    { id: 'market-template', label: 'Market template' },
    { id: 'selection-template', label: 'Selection template' }
];

const INHERITANCE_RULES = [
    { id: 'competition-to-event', label: 'Competition to event' },
    { id: 'market-template-to-market', label: 'Market template to market' },
    { id: 'selection-template-to-selection', label: 'Selection template to selection' }
];


class TagDefinitionForm extends Form {
    static propTypes = {
        ...Form.propTypes,
        tag: ImmutablePropTypes.map,
        sports: ImmutablePropTypes.list
    };

    static defaultProps = {
        ...Form.defaultProps,
        tag: Map(),
        sports: List()
    };

    onSubmit(e) {
        e.preventDefault();

        Form.prototype.onSubmit.call(this, e);
    }

    renderForm() {
        const { tag, sports } = this.props;

        return (
            <div className="tag-definition-form">
                { this.getCheckbox('multiselect', 'Multiselect') }

                <div className="row">
                    <div className="col-3">
                        {
                            this.getField(
                                <select label="Default value" { ...this.getFieldParameters('defaultValue') }>
                                    <option />
                                    {
                                        tag.get('values').map(val => (
                                            <option
                                                key={ val.get('id') }
                                                value={ val.get('id') }
                                            >
                                                { val.get('label') }
                                            </option>
                                        )).toArray()
                                    }
                                </select>
                            )
                        }
                    </div>
                    <div className="col-3">
                        {
                            this.getField(
                                <select
                                    multiple={ true }
                                    { ...this.getFieldParameters('sports') }
                                >
                                    {
                                        sports.map(val => (
                                            <option
                                                key={ val.get('id') }
                                                value={ val.get('id') }
                                            >
                                                { val.get('name') }
                                            </option>
                                        )).toArray()
                                    }
                                </select>
                            )
                        }
                    </div>
                    <div className="col-3">
                        {
                            this.getField(
                                <select
                                    multiple={ true }
                                    { ...this.getFieldParameters('applicableTo') }
                                >
                                    {
                                        APPLICABLE_TO.map(val => (
                                            <option key={ val.id } value={ val.id }>{ val.label }</option>
                                        ))
                                    }
                                </select>
                            )
                        }
                    </div>
                    <div className="col-3">
                        {
                            this.getField(
                                <select
                                    multiple={ true }
                                    { ...this.getFieldParameters('inheritance') }
                                >
                                    {
                                        INHERITANCE_RULES.map(val => (
                                            <option key={ val.id } value={ val.id }>{ val.label }</option>
                                        ))
                                    }
                                </select>
                            )
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default TagDefinitionForm;
